import React, { useState, useEffect } from 'react';
import { 
  FaBars, 
  FaTimes, 
  FaPhone, 
  FaWhatsapp, 
  FaEnvelope,
  FaChevronDown,
  FaUserCheck
} from 'react-icons/fa';
import './Header.css';
import btgLogo from '../../assets/images/Logo-BTG-3-removebg-preview.png';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleDropdown = (dropdown) => {
    setActiveDropdown(activeDropdown === dropdown ? null : dropdown);
  };

  const services = [
    {
      icon: '🎓',
      title: 'Admission',
      description: 'Dans les écoles françaises',
      link: '#btg-services'
    },
    {
      icon: '🏠',
      title: 'Logement',
      description: 'Étudiant en France',
      link: '#btg-services'
    },
    {
      icon: '📋',
      title: 'Visa',
      description: 'Étudiant',
      link: '#btg-services'
    },
    {
      icon: '💳',
      title: 'AVI',
      description: 'Attestation de Virement Irrévocable',
      link: '#btg-services'
    }
  ];

  const navItems = [
    { name: 'Accueil', link: '/' },
    { 
      name: 'Services', 
      link: '#btg-services',
      dropdown: services
    },
    { name: 'Témoignages', link: '#btg-temoignages' },
    { name: 'FAQ', link: '#btg-faq' },
    { name: 'Contact', link: 'contact' }
  ];

  return (
    <>
      {/* Main Header */}
      <header className={`btg-header-dark ${isScrolled ? 'btg-scrolled' : ''}`}>
        <div className="btg-container-dark">
          <nav className="btg-nav-dark">
            {/* Logo */}
            <div className="btg-logo-dark">
              <img 
                src={btgLogo} 
                alt="BTG CONSEIL" 
                className="btg-logo-image"
              />
            
            </div>

            {/* Desktop Navigation */}
            <ul className="btg-nav-menu-dark">
              {navItems.map((item, index) => (
                <li 
                  key={index} 
                  className="btg-nav-item-dark"
                  onMouseEnter={() => item.dropdown && toggleDropdown(item.name)}
                  onMouseLeave={() => item.dropdown && toggleDropdown(null)}
                >
                  <a 
                    href={item.link} 
                    className="btg-nav-link-dark"
                  >
                    {item.name}
                    {item.dropdown && <FaChevronDown className="btg-dropdown-arrow" />}
                  </a>

                  {/* Dropdown Menu */}
                  {item.dropdown && activeDropdown === item.name && (
                    <div className="btg-dropdown-menu-dark">
                      <div className="btg-dropdown-content">
                        {item.dropdown.map((service, serviceIndex) => (
                          <a 
                            key={serviceIndex} 
                            href={service.link}
                            className="btg-dropdown-item-dark"
                          >
                            <div className="btg-dropdown-icon">
                              {service.icon}
                            </div>
                            <div className="btg-dropdown-text">
                              <div className="btg-dropdown-title">
                                {service.title}
                              </div>
                              <div className="btg-dropdown-desc">
                                {service.description}
                              </div>
                            </div>
                          </a>
                        ))}
                      </div>
                    </div>
                  )}
                </li>
              ))}
            </ul>

            {/* CTA Button */}
            <div className="btg-header-actions">
              <button className="btg-main-cta-btn">
                <FaUserCheck />
                Demander un Devis
              </button>
            </div>

            {/* Mobile Menu Button */}
            <button 
              className="btg-mobile-toggle"
              onClick={toggleMenu}
            >
              {isMenuOpen ? <FaTimes /> : <FaBars />}
            </button>
          </nav>
        </div>

        {/* Mobile Menu */}
        <div className={`btg-mobile-menu-dark ${isMenuOpen ? 'btg-active' : ''}`}>
          <div className="btg-mobile-menu-content">
            {navItems.map((item, index) => (
              <div key={index} className="btg-mobile-nav-item">
                <a 
                  href={item.link} 
                  className="btg-mobile-nav-link"
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.name}
                </a>
                {item.dropdown && (
                  <div className="btg-mobile-dropdown">
                    {item.dropdown.map((service, serviceIndex) => (
                      <a 
                        key={serviceIndex} 
                        href={service.link}
                        className="btg-mobile-dropdown-item"
                        onClick={() => setIsMenuOpen(false)}
                      >
                        <div className="btg-mobile-dropdown-icon">
                          {service.icon}
                        </div>
                        <span>{service.title}</span>
                      </a>
                    ))}
                  </div>
                )}
              </div>
            ))}
            
            {/* Mobile Contact Info */}
            <div className="btg-mobile-contact">
              <a href="tel:+33763705088" className="btg-mobile-contact-link">
                <FaPhone />
                <span>+33 7 63 70 50 88</span>
              </a>
              <a href="https://wa.me/33763705088" className="btg-mobile-contact-link">
                <FaWhatsapp />
                <span>WhatsApp</span>
              </a>
              <a href="mailto:contact@btgconseil.com" className="btg-mobile-contact-link">
                <FaEnvelope />
                <span>Email</span>
              </a>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;